import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer>
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-logo">
            <span className="s">S</span><span className="d">D</span><span className="n">N</span>
          </div>
          <div className="footer-logo-sub">Savoie Dauphiné Nuisibles</div>
          <p>Artisan certifié en traitement des nuisibles. Intervention rapide, résultats garantis en Savoie et Grésivaudan.</p>
          <div className="footer-certs">
            <span>✓ Certifié Biocide</span>
            <span>✓ RC Pro</span>
          </div>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li><Link to="/#services">Désinsectisation</Link></li>
            <li><Link to="/#services">Guêpes & Frelons</Link></li>
            <li><Link to="/#services">Punaises de lit</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Zone</h4>
          <ul>
            <li><Link to="/#zone">Savoie (73)</Link></li>
            <li><Link to="/#zone">Isère (38)</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <ul>
            <li><a href="tel:0624314434">📞 06 24 31 44 34</a></li>
            <li><a href="mailto:contact@sdn-nuisibles.fr">✉️ contact@sdn-nuisibles.fr</a></li>
            <li><Link to="/#urgences">🚨 Urgences 7j/7</Link></li>
            <li><Link to="/#contact">📋 Devis gratuit</Link></li>
            <li><Link to="/#faq">❓ FAQ</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-copy">
          © {new Date().getFullYear()} SDN – Savoie Dauphiné Nuisibles · SIRET : 101 891 307 00015
        </div>
        <div className="footer-legal">
          <Link to="/mentions-legales">Mentions légales</Link>
          <Link to="/confidentialite">Confidentialité</Link>
          <Link to="/cgv">CGV</Link>
        </div>
      </div>
    </footer>
  );
}
